class OsianderRedirect extends HTMLElement {

    static {
        if (!customElements.get("osiander-redirect")) {
            customElements.define("osiander-redirect", this);
        }
    }

    connectedCallback() {
        this.querySelector("dialog").showModal();
    }

}

/**
 * Wartet auf den Abschluss des Usercentrics-Consent-Dialogs, bevor callback
 * ausgeführt wird.
 *
 * Kopiert aus components/laender-weiche/main.js — dort steht die ausführliche
 * Herleitung. Kurzfassung: "UC_UI_INITIALIZED" bedeutet nur, dass die CMP-
 * Bibliothek geladen ist, NICHT dass der Nutzer entschieden hat. Das echte
 * Signal ist window.UC_UI.isConsentRequired() === false (wiederkehrender
 * Besucher mit gespeicherter Entscheidung) bzw. das Event "UC_UI_CMP_EVENT"
 * mit type ACCEPT_ALL/DENY_ALL/SAVE (Erstbesucher schließt den Banner).
 *
 * Für dieses Overlay ist das besonders relevant: Wer frisch von osiander.de
 * umgeleitet wird, sieht den Consent-Banner in aller Regel zum ersten Mal.
 * Ohne das Gate läge das Overlay über dem offenen Banner.
 *
 * Der Timeout-Fallback greift nur, wenn das CMP technisch gar nicht lädt
 * (Adblocker, Netzwerkproblem). Existiert window.UC_UI, wird ohne weiteren
 * Timeout auf die Entscheidung gewartet.
 *
 * Geteilt wird der Code bewusst nicht: thalia build behandelt jedes
 * Verzeichnis unter components/ als eigenständige Component mit eigenem
 * Bundle, ein gemeinsames Modul ist im Build-Setup nicht vorgesehen.
 */
function afterConsentDecided(callback, timeoutMs = 4000) {
    let done = false;
    const proceed = () => { if (!done) { done = true; callback(); } };

    function isDecisionEvent(event) {
        const type = event.detail?.type;
        return type === "ACCEPT_ALL" || type === "DENY_ALL" || type === "SAVE";
    }

    function onCmpReady() {
        if (!window.UC_UI.isConsentRequired?.()) {
            proceed();
            return;
        }
        // Named, damit der Listener nach der Entscheidung wieder abgeräumt wird.
        // Kein { once: true }: Das CMP feuert UC_UI_CMP_EVENT auch für Ereignisse,
        // die keine Entscheidung sind — der Listener würde dann zu früh verschwinden
        // und das Overlay nie öffnen.
        const onCmpEvent = (event) => {
            if (isDecisionEvent(event)) {
                window.removeEventListener("UC_UI_CMP_EVENT", onCmpEvent);
                proceed();
            }
        };
        window.addEventListener("UC_UI_CMP_EVENT", onCmpEvent);
    }

    if (window.UC_UI?.isInitialized?.()) {
        onCmpReady();
    } else {
        window.addEventListener("UC_UI_INITIALIZED", onCmpReady, { once: true });
    }

    setTimeout(() => {
        if (!window.UC_UI) {
            proceed();
        }
    }, timeoutMs);
}

try {
    const template = document.getElementById("osiander-redirect");
    if (template) {
        // Exakter Vergleich statt hash.includes(...): Ein unscharfer Test würde
        // auch bei fremden Hashes wie #osiander-filiale anschlagen.
        const cameFromOsiander = window.location.hash === "#osiander";

        // Ohne diese Prüfung erschiene das Overlay auch auf Submandanten wie
        // 2003 (app.thalia.de), falls das Snippet dort eingebunden wird.
        const currentMandantId = document.querySelector('meta[name="mandant"]')?.content;
        const hauptmandantId = template.dataset.hauptmandantId;
        const isHauptmandant = Boolean(hauptmandantId) && currentMandantId === hauptmandantId;

        if (cameFromOsiander && isHauptmandant) {
            afterConsentDecided(() => {
                document.body.appendChild(template.content.cloneNode(true));
                // Ohne Persistenzschicht ist der Hash das einzige Signal. Wird er
                // nach dem Öffnen entfernt, zeigt ein Reload das Overlay nicht
                // erneut — und die Adresszeile bleibt sauber, falls der Nutzer
                // die Seite teilt.
                history.replaceState(null, "", location.pathname + location.search);
            });
        }
    }
} catch (error) {
    // Das Overlay ist unkritisch — ein Fehler hier darf die Seite nicht stören.
    // Eine Warnung hinterlässt aber eine Spur, wenn das Overlay unerwartet ausbleibt.
    console.warn("osiander-redirect: Overlay konnte nicht initialisiert werden", error);
}
